<template>
  <section id="services">
    <div v-if="isMobile">
      <SwiperLayout :autoplay="swiperAutoplay" :pagination="false">
        <SwiperSlide v-for="n in 4">
          <div class="service">
            <div class="image-container">
              <img :src="`/img/home/icon_${n}.png`" alt="Icon" />
            </div>
            <h3 v-html="$t(`services_${n}`)"></h3>
          </div>
        </SwiperSlide>
      </SwiperLayout>
    </div>
    <div class="inner" v-else>
      <div class="row">
        <div v-for="n in 4" class="col-lg col-md-4 col-sm-6 col-xs-6 service">
          <div class="image-container">
            <img :src="`/img/home/icon_${n}.png`" alt="Custom" />
          </div>
          <h3 v-html="$t(`services_${n}`)"></h3>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { SwiperSlide } from "swiper/vue";
import { isMobileDevice } from "./../../../helpers";
import SwiperLayout from "./../../packages/views/carousel/Layout";
import { useToast } from "vue-toastification";

export default {
  components: {
    SwiperLayout,
    SwiperSlide,
  },
  props: {
    flashMessage: {
      type: String,
    },
  },
  data() {
    return {
      swiperAutoplay: { delay: 2500, disableOnInteraction: false },
    };
  },
  mounted() {
    if (this.flashMessage) {
      setTimeout(() => {
        this.toast.success(this.flashMessage);
      }, 1000);
    }
  },
  setup() {
    const toast = useToast();
    const isMobile = isMobileDevice();

    return {
      toast,
      isMobile,
    };
  },
};
</script>
